import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CircleLoader, Typography } from "@jti/ui";
import { useFreeTrial } from "../../hooks/useFreeTrial";
import { useOrder } from "../../hooks/useOrder";
import { OrderSummaryItemsList } from "./OrderSummaryItemsList";
import { OrderSummaryPayment } from "./OrderSummaryPayment";
import { OrderSummaryRedirectToOrder } from "./OrderSummaryRedirectToOrder";
import styles from "./OrderSummary.module.scss";
export const OrderSummary = ({ additionalTaxInfo, title, pointsToEarn, showDetailedSummary }) => {
    const { isFreeTrial } = useFreeTrial();
    const { order, orderFetchStatus } = useOrder();
    if (orderFetchStatus === "idle") {
        return null;
    }
    if (orderFetchStatus === "pending") {
        return _jsx(CircleLoader, {});
    }
    return (_jsxs("div", { className: styles.orderSummary, children: [_jsxs("div", { className: styles.contentWrapper, children: [_jsx(Typography, { className: styles.title, variant: "h4", children: title }), _jsxs("div", { className: styles.content, children: [_jsx(OrderSummaryItemsList, { className: styles.list, items: order?.items || [] }), _jsx(OrderSummaryPayment, { className: styles.payment, pointsToEarn: pointsToEarn, additionalTaxInfo: additionalTaxInfo, showDetailedSummary: showDetailedSummary })] })] }), _jsx(OrderSummaryRedirectToOrder, { orderId: order?.number, isFreeTrial: isFreeTrial })] }));
};
//# sourceMappingURL=OrderSummary.js.map